var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$isIframe)?_c('div',[_c('router-view')],1):_c('div',[_c('h1',{staticStyle:{"color":"red","text-align":"center","margin-top":"20%"}},[_vm._v(" Access denied. This page cannot be loaded in an iframe. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }